import { c as _c } from "react/compiler-runtime";
import styles from './profile-summary.module.scss';
export type ProfileSummaryProps = {
  companyName?: string;
  content?: {
    greeting?: string;
    mdrtId?: Nullable<string>;
    membershipYears?: Nullable<string>;
  };
  designations: string[];
  gracePeriod?: Nullable<string>;
  location?: string;
  profileName: Nullable<string>;
  profileNameSecondary?: Nullable<string>;
};
export const ProfileSummary = t0 => {
  const $ = _c(25);
  const {
    companyName,
    content,
    designations,
    gracePeriod,
    location,
    profileName,
    profileNameSecondary
  } = t0;
  let t1;
  if ($[0] !== content?.greeting) {
    t1 = content?.greeting && <div className={styles.welcome}>{content?.greeting}</div>;
    $[0] = content?.greeting;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== profileName) {
    t2 = <div className={styles["full-name"]} data-testid="profile-summary-full-name">{profileName}</div>;
    $[2] = profileName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== profileNameSecondary) {
    t3 = profileNameSecondary && <div className={styles["full-name-secondary"]} data-testid="profile-summary-full-name-secondary">({profileNameSecondary})</div>;
    $[4] = profileNameSecondary;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== designations) {
    t4 = designations.length > 0 && <div className={styles.designations} data-testid="profile-summary-designations">{designations?.join(", ")}</div>;
    $[6] = designations;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== companyName) {
    t5 = companyName && <div className={styles["company-name"]}>{companyName}</div>;
    $[8] = companyName;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== content) {
    t6 = (content?.membershipYears || content?.mdrtId) && <div className={styles["info-row"]}>{content.membershipYears && <><span data-testid="profile-summary-membership-year">{content.membershipYears}</span><div className={styles.separator}><div className={styles.separator__line} /></div></>}<span data-testid="profile-summary-mdrt-id">{content.mdrtId}</span></div>;
    $[10] = content;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== location) {
    t7 = location && <div className={styles.location}>{location}</div>;
    $[12] = location;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== gracePeriod) {
    t8 = gracePeriod && <div className={styles["grace-period-indicator"]}>{gracePeriod}</div>;
    $[14] = gracePeriod;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t1 || $[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8) {
    t9 = <div className={styles.container} data-testid="profile-summary-container">{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}</div>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};